import { LinqPredicateDTO } from "@eqproject/eqp-filters";

export class ImportExportDTO {
  // Commons
  EntityTypeName: string;
  FileType: FileTypeEnum;
  MimeType: string;
  ApplyFormatToLabels: boolean;
  RemoveHeader: boolean;
  Filters: Array<LinqPredicateDTO>;

  // Csv
  AreLabelsWithoutFormat: boolean;
  IsHeaderMissing: boolean;
  Delimiter: string;
  Eol: string;
  TextQualifier: string;
  NumberOfColumns: number;

  // Xlsx
  AutofitColumns: boolean;
  HeaderStyle: HeaderStyleDTO;
  ApplyDateFormatToColumns: boolean;
}

export enum FileTypeEnum {
  "csv" = 1,
  "xlsx" = 2
}

export class HeaderStyleDTO {
  FontName: string;
  FontSize: number;
  IsBold: boolean;
  IsItalic: boolean;
  BackgroundColor: string;
  FontColor: string;
}
